import { Grid, Tabs, Tab, Typography, Button, IconButton, Menu, MenuItem} from '@material-ui/core'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { withStyles } from '@material-ui/core/styles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import './AppointmentDetails.scss'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'
import { makeStyles } from '@material-ui/styles'
import { TIMEZONE_OPTONS } from '../../constants/timezones'
import { date } from 'yup'
import { getAppointmentListUpcomingPrevious } from '../../services/Appointments/appointments'
import { confirmedAppointmentStart } from '../../store/actions/appointments'
import { useHistory } from 'react-router-dom'
import { me } from '../../services/Login/login'
import { changeHeaderTab } from '../../store/actions/header'
import { reversedHeaderConstants } from '../Header/constants'
import GTranslateIcon from '@mui/icons-material/GTranslate';
import CDPH from '../../assests/images/cdph.png'

const useStyles = makeStyles(() => ({
    disabledButton: {
        backgroundColor: '#C0C1C5 !important',
        color: 'rgba(255, 255, 255, 0.7) !important',
    },
}))

const AppointmentDetails = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const loggedinPatiendataOld = useSelector((state) => state?.login?.userData)
    const [loggedinPatiendata, setLoggedinPatiendata] = useState(loggedinPatiendataOld)
    // const [startTime, setStatrttime] = useState('')

    // const toggleOpen = () => {
    //     setOpen(true)
    //     setCurrentTab(0)
    // }
    const memorizing = useMemo(() => loggedinPatiendata, [loggedinPatiendata])

    const [appointmentTime, setAppointmentTime] = React.useState('')
    const [anchorEl, setAnchorEl] = useState(null)
    
    const formatTimeZone = () => {
        if (loggedinPatiendata?.next_appointment?.start) {
        // if (startTime) {
            const utcTime = moment.utc(loggedinPatiendata?.next_appointment?.start),
                userTimezone = TIMEZONE_OPTONS?.find(
                    (timezoneList) =>
                        timezoneList.key ===
                        (loggedinPatiendata?.timezone || loggedinPatiendata?.data?.timezone),
                )?.abbr

            const pstTime = utcTime.tz(memorizing?.timezone || 'US/Pacific')
            const formattedTime = pstTime.format(
                `MMMM Do, YYYY [at] h:mma [${userTimezone || 'PST'}]`,
            )

            return formattedTime?.toString()?.split('at')
        }
        return ''
    }

    React.useEffect(() => {
        setAppointmentTime(formatTimeZone())
    }, [loggedinPatiendata])
    

    // the auto polling concept commented for advanceMd, becuse there is no need to call the api again and again 
    // const intervalRef = useRef(null);


    // // appoinetment list every 30sec
    // useEffect(() => {
    //     if (intervalRef.current) {
    //         clearInterval(intervalRef.current);
    //     }
    //     intervalRef.current = setInterval(() => {
    //         appointmentConfirmedList()
    //     }, 30000); //30sec
    //     return () => {
    //         if (intervalRef.current) {
    //             clearInterval(intervalRef.current);
    //         }
    //     };
    // })


    const Banner = () => (
        <div
            style={{
                // marginRight: '2rem',
                display: 'flex',
                alignItems: 'baseline',
            }}>
            <span className="appointmentTextStart">
                If you are in crisis or having an emergency, please call 911 | If you need any assistance please call or text us at{' '}
                <span
                    style={{
                        fontWeight: '500',
                    }}>
                    {}
                    {loggedinPatiendata?.practice?.patient_support_number || '(562) 268-0955'}
                </span>
            </span>
        </div>
    )
    return (
        <>
            <div
                className="app_appointmentdeatis_header"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <>
                        {/* <img
                            src={CDPH}
                            style={{ marginLeft: '30%', width: '100px', cursor:'pointer' }}
                            onClick={() => {
                                window.location.reload()
                            }}
                        /> */}
                        <span className="appointmentTextStart">
                            {/* You have no upcoming appointments,{' '} */}
                            {/* <a
                                    className="appointmentTextStart book-now"
                                    style={{ color: 'white' }}
                                    onClick={travelToAppt}>
                                    Book Now!
                                </a> */}
                            {/* <IconButton
                                    onClick={(e) => {
                                        setAnchorEl(e.currentTarget)
                                    }}>
                                    <GTranslateIcon style={{ color: 'white' }} />
                                </IconButton>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={() => setAnchorEl(null)}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}>
                                    <MenuItem onClick={()=>{setAnchorEl(null),handleChange('en')}}>English</MenuItem>
                                    <MenuItem onClick={()=>{setAnchorEl(null),handleChange('es')}}>Spanish</MenuItem>
                                </Menu> */}
                        </span>
                    </>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'baseline',
                    }}>
                    <span className="appointmentTextStart">
                        If you are in crisis or having an emergency, please call 911 | If you need
                        any assistance please call or text us at{' '}
                        <span
                            style={{
                                fontWeight: '500',
                            }}>
                            {}
                            {'(562) 268-0955'}
                        </span>
                    </span>
                </div>
                {/* <Banner /> */}
            </div>
        </>
    )
}

export default AppointmentDetails
